import * as actionTypes from "../actions/actionTypes";
import { 
    fetchRecordsSuccess, 
    clearRecords, 
    fetchRecordsStart,
    fetchRecordsFail,
    clearRecord
} from "../utility";

const initialState = {
    records: [],
    record: null,
    isLoading: false,
    error: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_YOUR_ACCOUNTS_START: return fetchRecordsStart(state);
        case actionTypes.FETCH_YOUR_ACCOUNTS_SUCCESS: return fetchRecordsSuccess(state, action.payload);
        case actionTypes.FETCH_YOUR_ACCOUNTS_FAIL: return fetchRecordsFail(state, action.payload);
        case actionTypes.CLEAR_YOUR_ACCOUNTS: return clearRecords(state);
        case actionTypes.CLEAR_YOUR_ACCOUNT: return clearRecord(state);
        default:
            return state;
    }
};

export default reducer;